<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal-dialog" role="dialog" aria-modal="true" aria-labelledby="relogin-title">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="relogin-title">{{ 'multi_account.session_expired_title' | translate }}</h5>
      <button type="button" class="btn-close" (click)="onCancel()" [attr.aria-label]="'buttons.cancel' | translate"></button>
    </div>
    <div class="modal-body">
      <p class="text-muted mb-3">{{ 'multi_account.session_expired_subtitle' | translate: { name: session.name } }}</p>

      <!-- Password form -->
      <div *ngIf="!showMfa">
        <div class="mb-3">
          <label class="form-label">{{ 'login.email' | translate }}</label>
          <input type="email" class="form-control" [value]="session.email" disabled />
        </div>
        <div class="mb-3">
          <label class="form-label">{{ 'multi_account.relogin_password_label' | translate }}</label>
          <input type="password" class="form-control" [(ngModel)]="password"
            autocomplete="current-password" (keyup.enter)="onSubmit()" />
        </div>
        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-light" (click)="onCancel()">{{ 'multi_account.cancel' | translate }}</button>
          <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="loading || !password">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
            {{ 'multi_account.relogin_btn' | translate }}
          </button>
        </div>
      </div>

      <!-- MFA form -->
      <div *ngIf="showMfa">
        <div class="mb-3">
          <label class="form-label">{{ 'login.mfa.code_label' | translate }}</label>
          <input type="text" class="form-control text-center" [(ngModel)]="mfaCode"
            maxlength="6" autocomplete="one-time-code" />
        </div>
        <div *ngIf="mfaError" class="alert alert-danger py-1 px-2 mb-2">
          {{ mfaError | translate }}
        </div>
        <div class="mb-3">
          <label class="form-check">
            <input type="checkbox" class="form-check-input" [(ngModel)]="rememberDevice" />
            <span class="form-check-label">{{ 'login.mfa.remember_device' | translate }}</span>
          </label>
        </div>
        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="onResendCode()" [disabled]="countdown > 0">
            {{ 'login.mfa.resend_btn' | translate }} <span *ngIf="countdown > 0">({{ countdown }}s)</span>
          </button>
          <button type="button" class="btn btn-primary" (click)="onVerifyCode()" [disabled]="loading || mfaCode.length !== 6">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
            {{ 'multi_account.relogin_btn' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
